<style scoped lang="scss">
    @import "../../styles/mixins";
    @import "../../styles/var";

    .piclist {
        img {
            @include w_h(80px);
        }
    }
</style>

<template>
    <div>
        <!--<v-title title="病情资料" style="margin-left: -15px"></v-title>-->
        <hos_apply_title title="病情资料"></hos_apply_title>
        <el-form ref="form" :model="form" class="mt20" label-position="left" :rules="diseaseRule" size="mini">
            <el-form-item label="初步诊断" label-width="80px" prop="tentativeDiagnosis">
                <el-input v-model="form.tentativeDiagnosis" placeholder="请输入初步诊断内容"></el-input>
            </el-form-item>
            <el-form-item label="病情描述" label-width="80px">
                <el-input type="textarea" @input="changeLength"  :autosize="{ minRows: 4, maxRows: 10}" placeholder="请输入病情内容最多输入500字..." v-model="form.illnessDescription" :maxlength="500">
                </el-input>
            </el-form-item>
            <el-form-item label="病历附件" label-width="80px">
                <hos_flie_load ref="fileLoad" :atta="form.attaIdList"></hos_flie_load>
            </el-form-item>

            <!--<el-form-item label="初步诊断">-->
                <!--<v-textarea v-model="form.tentativeDiagnosis" placeholder="请输入初步诊断"-->
                            <!--:readonly="readonly&&needOpen===false"></v-textarea>-->
            <!--</el-form-item>-->
            <!--<el-form-item>-->
                <!--<div class="" slot="label" style="line-height: 20px">病情描述</div>-->
                <!--<v-textarea v-model="form.illnessDescription" placeholder="请输入申请会诊目的（或事由）"-->
                            <!--:readonly="readonly&&needOpen===false"></v-textarea>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="病历附件">-->
                <!--<template v-if="readonly&&needOpen===false">-->
                    <!--<ul class="piclist flex pt5">-->
                        <!--<li v-for="(data,index) in picList" class="mr5 mb5">-->
                            <!--<img :src="data.url" alt="">-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</template>-->
                <!--<el-upload v-else class="mt10"-->
                           <!--accept="image/*"-->
                           <!--list-type="picture-card"-->
                           <!--:on-error="uploadOnError"-->
                           <!--:on-change="uploadOnChange1"-->
                           <!--:action="API_URL"-->
                           <!--:limit="9"-->
                           <!--:file-list="picList"-->
                           <!--:data="upload1"-->
                           <!--:headers="UPLOAD_HEADERS">-->
                    <!--<i class="el-icon-plus"></i>-->
                    <!--<div class="fs14 color_333" slot="tip">-->
                        <!--最多可上传9张图片，支持jpg、png、gif、bmp、PDF格式。-->
                    <!--</div>-->
                <!--</el-upload>-->
            <!--</el-form-item>-->
        </el-form>
    </div>
</template>

<script>
  import VTitle from "../common/v-title";
  import hos_apply_title from "../hos/hos-apply-title"
  import hos_flie_load from "../hos/hos-flie-load"
  import VTextarea from "../common/v-textarea";
  import {UploadMixin} from "../../lib/mixins/upload";
  import {pickByArray} from "../../lib/utils";
  import {diseaseRule} from "../../lib/hos/until"

  export default {
    name: "referral-condition-form",
    components: {hos_apply_title,hos_flie_load},
    props: {
      readonly: {
        type: Boolean,
        default: false,
      },
      aspectUser: String,
      value: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    data() {
      return {
        picList: [],
        form: {
          tentativeDiagnosis: '',
          illnessDescription: '',
          attaIdList: []
        },
          diseaseRule
      }
    },
    computed: {
      upload1() {
        return {...this.UPLOAD_PARAMS, fileType: 'IMAGE', module: 'BASE'};
      },
      referralStatus() {
        return this.value.referralStatus || '';
      },
      auditStatus() {
        return this.value.auditStatus || false;
      },
      needOpen() {
        const {referralStatus, aspectUser, auditStatus} = this;
        if (aspectUser === 'init' && referralStatus === 'WAIT_EXAMINE' && auditStatus === false) {
          return true;
        }
        return false;
      }
    },
    mixins: [UploadMixin],
    watch: {
      // value: {
      //   deep: true,
      //   handler(newV) {
      //     this.form = {...pickByArray(newV, ['tentativeDiagnosis', 'illnessDescription', 'attaList'])};
      //     if (newV.attaList) {
      //       this.picList = newV.attaList.map(r => {
      //         return {
      //           id: r.id,
      //           name: r.attaFileName,
      //           url: r.attaFileUrl
      //         }
      //       });
      //       this.$set(this.form, 'attaIdList', this.picList.map(r => r.id));
      //     }
      //   }
      // }
    },
    methods: {
      getForm() {
          let vail = true;
          this.$refs['form'].validate((valid) => {
              if (!valid) {
                  vail = false
                  return false;
              }
          });

        let form =   Object.assign({},this.form,this.$refs['fileLoad'].getAttaList());//合并对象
          console.log('病人病情描述表单:');
          console.log(form);
        return {form:form,vail:vail};
      },
      uploadOnChange1(file, fileList) {
        this.picList = fileList.map(r => {
          if (r.response && r.response.code === '0') {
            r.url = r.response.obj.attaFileUrl;
            r.id = r.response.obj.id;
          }
          return r;
        });
        this.$set(this.form, 'attaIdList', this.picList.map(r => r.id));
      },
        changeLength(){
            if(this.form.illnessDescription.length >= 500){
                this.$message.error('字数超出限制。');
            }
        },
        setAgainData(){
            const cache = this.$cache.get('referralOrderCache');
            this.referralOrder = {...pickByArray(cache, ['tentativeDiagnosis', 'illnessDescription'])}
            console.log('atta')
            console.log(cache.attaList)
            this.form = Object.assign({},this.form,this.referralOrder);
            this.form.attaIdList = cache.attaList;
        }
    },
      created() {
        const {query} = this.$route;
        if(query.again){
            this.setAgainData();
        }
      }
  }
</script>
